import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import styles from "./KrogerReport.module.scss";
import OverallSummary from "./OverallSummary";
import RegionSummary from "./RegionSummary";
import StoreSummary from "./StoreSummary";
import ItemSummary from "./ItemSummary";
import BillbackSummary from "./BillbackSummary";
import DateRangeFilter from "../../components/calendar/DateRangeFilter";
const KrogerReportTab = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const EMPTY_RANGE = { startDate: null, endDate: null };
  const [dateRange, setDateRange] = useState(EMPTY_RANGE);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const tabs = [
    {
      header: "Overall Summary",
      Component: OverallSummary,
      showDateFilter: true
    },
    {
      header: "Region Summary",
      Component: RegionSummary,
      showDateFilter: true
    },
    { header: "Store Summary", Component: StoreSummary, showDateFilter: true },
    { header: "Item Summary", Component: ItemSummary, showDateFilter: false },
    {
      header: "Billback Summary",
      Component: BillbackSummary,
      showDateFilter: false
    }
  ];

  const showDateFilter = tabs[activeIndex]?.showDateFilter;

  return (
    <div>
      <div className="grid ">
        <div className="col-12 ">
          {showDateFilter && (
            <DateRangeFilter value={dateRange} onChange={setDateRange} />
          )}
          <TabView
            className={`${styles.noBorderForTab} ${styles.tabViewBotttomBorder}`}
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            scrollable
          >
            {tabs.map(({ header, Component }, index) => (
              <TabPanel
                key={header}
                header={header}
                headerClassName={styles.tabWidth}
                className={`${styles.tab} ${
                  activeIndex === index ? styles.activeTab : styles.InactiveTab
                }`}
              >
                <Component dateRange={dateRange} />
              </TabPanel>
            ))}
          </TabView>
        </div>
      </div>
    </div>
  );
};

export default KrogerReportTab;
